module.exports = __webpack_public_path__ + "static/media/Rain.45ab8056.png";